import { COUNTRY_BY_REGION_LIST, IS_ERROR, IS_UNAUTHORIZED, GET_ALL_COUNTRIES, SHOW__HIDE_LOADER } from '../constants/constants';

export const countryRegionListBySurveyId = (value: any) => {
    return {
        type: COUNTRY_BY_REGION_LIST,
        payload: value
    }
}

export const countryRegionList = () => {
    return {
        type: COUNTRY_BY_REGION_LIST
    }
}

export const isError = (value: any) =>{
    return{
        type: IS_ERROR,
        payload: value
    }
}

export const isUnauthorized = (value: any) =>{
    return{
        type: IS_UNAUTHORIZED,
        payload: value
    }
}

export const getAllCountries = () =>{
    return{
        type: GET_ALL_COUNTRIES
    }
}

export const setLoaderVisibility = (data: any) => {
    console.log('setLoaderVisibility', data);
    return{
        type: SHOW__HIDE_LOADER, 
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/action.common.tsx